import { Link } from 'react-router-dom';

const points = [
  {
    icon: 'ri-book-open-line',
    title: '分集剧情档案',
    desc: '十二集逐集整理，包含播出日期、时长与关键线索，方便回看与对照。',
  },
  {
    icon: 'ri-user-star-line',
    title: '演员与角色对照',
    desc: '八位主创资料，说明演员本人与剧中角色的关系，以及角色的处境。',
  },
  {
    icon: 'ri-newspaper-line',
    title: '动态与幕后',
    desc: '收视消息、主创访谈、场景搭建花絮，持续补充这个故事的周边信息。',
  },
];

export default function SiteIntro() {
  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.24em] text-primary-600">ABOUT THE ARCHIVE</p>
            <h2 className="mt-2 font-heading text-xl leading-snug text-foreground-950 md:text-2xl">
              一个家的故事，
              <br />
              值得被慢慢读完
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              本站围绕《禁止的爱善良的小姨子》整理剧情、演员与动态资料，不提供视频播放与下载，
              所有内容以文字与图文专题的形式呈现，供观众在追剧之后回看细节、理解人物。
            </p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-700"
            >
              了解本站
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:col-span-8">
            {points.map((point) => (
              <div
                key={point.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                  <i className={point.icon} />
                </span>
                <h3 className="mt-4 font-heading text-base text-foreground-900">{point.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-500">{point.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}